import endOfMonth from 'date-fns/endOfMonth';
import endOfYear from 'date-fns/endOfYear';
import endOfWeek from 'date-fns/endOfWeek';
import startOfDay from 'date-fns/startOfDay';
import startOfMonth from 'date-fns/startOfMonth';
import startOfYear from 'date-fns/startOfYear';
import startOfWeek from 'date-fns/startOfWeek';

import { DateRangeType } from 'shared/constants';

export function getDatesByDateFilter(dateRangeType: DateRangeType) {
  const today = startOfDay(new Date());

  switch (dateRangeType) {
    case DateRangeType.ThisYear:
      return { startDate: startOfYear(today), endDate: endOfYear(today) };
    case DateRangeType.ThisMonth:
      return { startDate: startOfMonth(today), endDate: endOfMonth(today) };
    case DateRangeType.ThisWeek:
      return {
        startDate: startOfWeek(today, { weekStartsOn: 1 }),
        endDate: endOfWeek(today, { weekStartsOn: 1 }),
      };
    case DateRangeType.Today:
      return { startDate: today, endDate: today };
    default:
      return { startDate: null, endDate: null };
  }
}
